import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useFetch, { CachePolicies } from 'use-http';
import AgreementUsers from './AgreementUsers';
import { WSAUserDto } from 'dto/user.dto';

const options: { cachePolicy: CachePolicies; cacheTime: number } = {
	cachePolicy: CachePolicies.CACHE_FIRST,
	cacheTime: 10000,
};

const host = process.env.REACT_APP_BACKEND_URL;

export default function AcceptUser() {
	const { get } = useFetch(host, options);

	const navigate = useNavigate();
	const { code } = useParams();
	const [users, setUsers] = React.useState([]);

	const load = React.useCallback(async () => {
		if (code) {
			const data = await get(`/api/users/byBarcode?barcode=${code}`);
			if (data?.length > 0) {
				setUsers(data);
			}
		}
	}, [code]);

	React.useEffect(() => {
		load();
	}, [load]);

	const handleAccept = React.useCallback(
		async (selectedUser: WSAUserDto) => {
			navigate(`/manual/photo/${selectedUser.id}`);
		},
		[code],
	);

	const handleCancel = React.useCallback(async () => {
		navigate(`/manual`);
	}, []);

	const handleNoneSelected = React.useCallback(() => {
		navigate(`/manual`);
	}, []);

	return (
		<div>
			{users.length > 0 && (
				<AgreementUsers
					onAccept={handleAccept}
					onCancel={handleCancel}
					onNoneSelected={handleNoneSelected}
					users={users}
				/>
			)}
		</div>
	);
}
